import { Input } from 'antd';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Label } from '../components/index';
import styles from '../index.less';

const cx = classNames.bind(styles);

const defaultProps = {
  labelColor: 'rgba(0, 0, 0, 0.3)',
  placeholder: '',
  withSearch: false,
  enterButton: false,
  onChange: null,
  addonAfter: null,
};
const propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
  ]).isRequired,
  labelColor: PropTypes.string,
  placeholder: PropTypes.string,
  withSearch: PropTypes.bool,
  enterButton: PropTypes.oneOfType([PropTypes.bool, PropTypes.element]),
  onChange: PropTypes.func,
  addonAfter: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  handleSearch: PropTypes.func,
  handleFocus: PropTypes.func,
};

class FloatLabelInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEmpty: true,
      isFocused: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value) {
      this.setState({ isEmpty: nextProps.value.length === 0 });
    }
  }

  onBlur = e => this.setState({ isFocused: false })

  onFocus = (e) => {
    e.stopPropagation();
    this.setState({ isFocused: true });

    const { handleFocus } = this.props;
    if (_.isFunction(handleFocus)) {
      handleFocus(e.target.value);
    }
  }

  onPressEnter = (e) => {
    const { handleSearch } = this.props;
    if (_.isFunction(handleSearch)) {
      handleSearch(e.target.value);
    }
  }

  onChange = (e) => {
    const { value } = e.target;
    this.setState({ isEmpty: value.length === 0 });

    const { onChange } = this.props;
    if (_.isFunction(onChange)) {
      onChange(value);
    }
  }

  getHrCls = (hasError) => {
    const { isFocused } = this.state;
    let hrCls = cx('default');
    if (isFocused) {
      hrCls += ` ${cx('highlighted')}`;
    }
    if (hasError) {
      hrCls += ` ${cx('hasError')}`;
    }
    return hrCls;
  }

  getLabelCls = () => {
    let labelCls = '';
    const { isEmpty, isFocused } = this.state;
    const shouldLabelRise = !(!isFocused && isEmpty);
    if (shouldLabelRise) {
      labelCls += ` ${cx('toTop')}`;
    }

    if (this.props.required) {
      labelCls += ` ${cx('required')}`;
    }

    return labelCls;
  }

  render() {
    const { isEmpty, isFocused } = this.state;
    const {
      label,
      labelColor,
      placeholder,
      withSearch,
      value,
      addonAfter,
      handleSearch,
      message,
      required,
      noLabel,
      enterButton,
    } = this.props;

    const shouldShowPlaceholder = isFocused && isEmpty;

    const hasError = required && value === '';

    return (
      <div className={classNames(cx('floatingInputWrapper'), 'floatingInputWrapper') + (hasError ? ' has-error' : '')}>
        <Label color={labelColor}>
          {label}
        </Label>
        <div className={cx('placeholder') + (shouldShowPlaceholder ? ` ${cx('show')}` : '')}>
          {placeholder}
        </div>
        {withSearch ? (
          <Input.Search
            defaultValue={value}
            onBlur={this.onBlur}
            onChange={this.onChange}
            onFocus={this.onFocus}
            onPressEnter={this.onPressEnter}
            onSearch={searchText => handleSearch(searchText)}
            enterButton={enterButton}
          />
        ) : (
          <Input
            value={value}
            onBlur={this.onBlur}
            onChange={this.onChange}
            onFocus={this.onFocus}
            addonAfter={addonAfter}
          />
        )}
        <div>
          <hr className={hasError ? cx('hasError') : ''} />
          <hr className={this.getHrCls(hasError)} />
        </div>
        {hasError && <div className="ant-form-explain inheritedFromAntd">{message}</div>}
      </div>
    );
  }
}

FloatLabelInput.defaultProps = defaultProps;
FloatLabelInput.propTypes = propTypes;
export default FloatLabelInput;



// WEBPACK FOOTER //
// ./src/components/page/FloatLabelInput/container/index.jsx